import { useState } from 'react'
import { DropdownList, StyledRadio } from '../GlobalComponents/Inputs/Inputs'
import { MenuItem } from '@material-ui/core'

export const DropdownListStory = () => {
    const list = ['1', '2', '3', '4', '5']
    const [value, setValue] = useState<string>(list[0])
    return (
        <div style={{ width: 200 }}>
            <DropdownList
                variant="outlined"
                title={'Dropdown'}
                value={value}
                onChange={(event: any) => {
                    setValue(event.target.value)
                }}
            >
                {Object.entries(list).map((keyValue) => {
                    let [key, value] = keyValue
                    return (
                        <MenuItem key={key} value={value}>
                            {value}
                        </MenuItem>
                    )
                })}
            </DropdownList>
        </div>
    )
}

export const StyledRadioStory = () => {
    const [checked, setChecked] = useState<string>('First')
    return (
        <>
            <div style={{ display: 'flex', gap: 6 }}>
                <StyledRadio
                    checked={checked === 'First'}
                    onChange={(state: boolean) => {
                        setChecked('First')
                    }}
                />
                <div>First</div>
            </div>
            <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                <StyledRadio
                    checked={checked === 'Second'}
                    onChange={(state: boolean) => {
                        setChecked('Second')
                    }}
                />
                <div>Second</div>
            </div>
            <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                <StyledRadio
                    checked={checked === 'Third'}
                    onChange={(state: boolean) => {
                        setChecked('Third')
                    }}
                />
                <div>Third</div>
            </div>
            <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                <StyledRadio
                    checked={checked === 'Fourth'}
                    onChange={(state: boolean) => {
                        setChecked('Fourth')
                    }}
                />
                <div>Fourth</div>
            </div>
        </>
    )
}
